import { LiveTrainingCardProps, TrainingStatus } from 'src/components/LiveTrainingCard';
import { FlattenedLearningInstance } from 'src/utils/almDataTransformer';

/**
 * Mock data for Live Training sessions to be used with LiveTrainingCard component
 */

// Individual training session mocks
export const upcomingJiraAdminTraining: LiveTrainingCardProps = {
  id: 'upcomingJiraAdminTraining',
  title: 'Advanced Jira Administration',
  subtitle: 'Master advanced Jira configuration, automation, and administration best practices',
  dateTime: '2025-11-15T10:00:00-08:00', // November 15, 2025 at 10:00 AM PST
  status: 'upcoming' as TrainingStatus,
  enrolled: true,
  product: 'Jira',
  label: 'Team training',
  host: 'John Smith',
  detailsLink: '/instructor-led-training/advanced-jira-admin',
  showAddToCalendar: true,
  showDownloadMaterials: false,
};

export const upcomingConfluenceTraining: LiveTrainingCardProps = {
  id: 'upcomingConfluenceTraining',
  title: 'Confluence Fundamentals',
  subtitle: 'Learn the basics of Confluence for effective team collaboration and documentation',
  dateTime: '2025-11-20T14:00:00-08:00', // November 20, 2025 at 2:00 PM PST
  status: 'upcoming' as TrainingStatus,
  enrolled: true,
  product: 'Confluence',
  label: 'Public class',
  host: 'Jane Doe',
  detailsLink: '/instructor-led-training/confluence-fundamentals',
  showAddToCalendar: true,
  showDownloadMaterials: false,
};

export const upcomingJSMTraining: LiveTrainingCardProps = {
  id: 'upcomingJSMTraining',
  title: 'Jira Service Management Essentials',
  subtitle: 'ITSM best practices and implementation strategies with Jira Service Management',
  dateTime: '2025-12-01T09:00:00-08:00', // December 1, 2025 at 9:00 AM PST
  status: 'upcoming' as TrainingStatus,
  enrolled: false,
  product: 'Jira Service Management',
  label: 'Public class',
  host: 'Mike Johnson',
  detailsLink: '/instructor-led-training/jsm-essentials',
  showAddToCalendar: true,
  showDownloadMaterials: false,
};

export const upcomingBitbucketTraining: LiveTrainingCardProps = {
  id: 'upcomingBitbucketTraining',
  title: 'Bitbucket for Teams',
  subtitle: 'Version control, code review, and CI/CD workflows with Bitbucket',
  dateTime: '2025-12-05T11:00:00-08:00', // December 5, 2025 at 11:00 AM PST
  status: 'upcoming' as TrainingStatus,
  enrolled: true,
  product: 'Bitbucket',
  host: 'Sarah Williams',
  detailsLink: '/instructor-led-training/bitbucket-teams',
  showAddToCalendar: true,
  showDownloadMaterials: false,
};

export const completedAgileJiraTraining: LiveTrainingCardProps = {
  id: 'completedAgileJiraTraining',
  title: 'Agile with Jira',
  subtitle: 'Implementing agile methodologies and best practices using Jira',
  dateTime: '2025-10-25T10:00:00-07:00', // October 25, 2025 at 10:00 AM PDT
  status: 'completed',
  enrolled: true,
  product: 'Jira',
  label: 'Team training',
  host: 'David Lee',
  detailsLink: '/instructor-led-training/agile-jira',
  showAddToCalendar: false,
  showDownloadMaterials: true,
};

export const completedConfluenceAdvancedTraining: LiveTrainingCardProps = {
  id: 'completedConfluenceAdvancedTraining',
  title: 'Confluence Advanced',
  subtitle: 'Advanced content creation, templates, and collaboration features',
  dateTime: '2025-10-18T15:00:00-07:00', // October 18, 2025 at 3:00 PM PDT
  status: 'completed',
  enrolled: true,
  product: 'Confluence',
  label: 'Public class',
  host: 'Emily Chen',
  detailsLink: '/instructor-led-training/confluence-advanced',
  showAddToCalendar: false,
  showDownloadMaterials: true,
};

export const completedCloudMigrationTraining: LiveTrainingCardProps = {
  id: 'completedCloudMigrationTraining',
  title: 'Atlassian Cloud Migration',
  subtitle: 'Best practices and strategies for migrating to Atlassian Cloud',
  dateTime: '2025-10-10T13:00:00-07:00', // October 10, 2025 at 1:00 PM PDT
  status: 'completed',
  enrolled: true,
  product: 'Atlassian',
  host: 'Alex Brown',
  detailsLink: '/instructor-led-training/cloud-migration',
  showAddToCalendar: false,
  showDownloadMaterials: true,
};

export const completedTrelloTraining: LiveTrainingCardProps = {
  id: 'completedTrelloTraining',
  title: 'Trello for Project Management',
  subtitle: 'Organize and manage projects effectively using Trello boards and power-ups',
  dateTime: '2025-09-28T14:30:00-07:00', // September 28, 2025 at 2:30 PM PDT
  status: 'completed',
  enrolled: true,
  product: 'Trello',
  label: 'Public class',
  host: 'Rachel Green',
  detailsLink: '/instructor-led-training/trello-pm',
  showAddToCalendar: false,
  showDownloadMaterials: true,
};

export const upcomingJiraAlignTraining: LiveTrainingCardProps = {
  id: 'upcomingJiraAlignTraining',
  title: 'Jira Align for Enterprise',
  subtitle: 'Enterprise agile planning and portfolio management with Jira Align',
  dateTime: '2025-12-10T10:00:00-08:00', // December 10, 2025 at 10:00 AM PST
  status: 'upcoming' as TrainingStatus,
  enrolled: false,
  product: 'Jira Align',
  label: 'Team training',
  host: 'Michael Scott',
  detailsLink: '/instructor-led-training/jira-align-enterprise',
  showAddToCalendar: true,
  showDownloadMaterials: false,
};

export const upcomingAutomationTraining: LiveTrainingCardProps = {
  id: 'upcomingAutomationTraining',
  title: 'Automation in Jira and Confluence',
  subtitle: 'Streamline workflows with powerful automation rules and integrations',
  dateTime: '2025-12-15T09:30:00-08:00', // December 15, 2025 at 9:30 AM PST
  status: 'upcoming' as TrainingStatus,
  enrolled: true,
  product: 'Jira',
  host: 'Lisa Anderson',
  detailsLink: '/instructor-led-training/automation',
  showAddToCalendar: true,
  showDownloadMaterials: false,
};

// Collections of training sessions by status
export const upcomingTrainingSessions: LiveTrainingCardProps[] = [
  upcomingJiraAdminTraining,
  upcomingConfluenceTraining,
  upcomingJSMTraining,
  upcomingBitbucketTraining,
  upcomingJiraAlignTraining,
  upcomingAutomationTraining,
];

export const completedTrainingSessions: LiveTrainingCardProps[] = [
  completedAgileJiraTraining,
  completedConfluenceAdvancedTraining,
  completedCloudMigrationTraining,
  completedTrelloTraining,
];

export const enrolledTrainingSessions: LiveTrainingCardProps[] = [
  upcomingJiraAdminTraining,
  upcomingConfluenceTraining,
  upcomingBitbucketTraining,
  upcomingAutomationTraining,
  completedAgileJiraTraining,
  completedConfluenceAdvancedTraining,
  completedCloudMigrationTraining,
  completedTrelloTraining,
];

export const notEnrolledTrainingSessions: LiveTrainingCardProps[] = [upcomingJSMTraining, upcomingJiraAlignTraining];

export const allTrainingSessions: LiveTrainingCardProps[] = [...upcomingTrainingSessions, ...completedTrainingSessions];

// Training sessions by product
export const jiraTrainingSessions: LiveTrainingCardProps[] = [
  upcomingJiraAdminTraining,
  completedAgileJiraTraining,
  upcomingAutomationTraining,
];

export const confluenceTrainingSessions: LiveTrainingCardProps[] = [
  upcomingConfluenceTraining,
  completedConfluenceAdvancedTraining,
];

export const jsmTrainingSessions: LiveTrainingCardProps[] = [upcomingJSMTraining];

export const bitbucketTrainingSessions: LiveTrainingCardProps[] = [upcomingBitbucketTraining];

// Training sessions by label type
export const teamTrainingSessions: LiveTrainingCardProps[] = [
  upcomingJiraAdminTraining,
  completedAgileJiraTraining,
  upcomingJiraAlignTraining,
];

export const publicClassSessions: LiveTrainingCardProps[] = [
  upcomingConfluenceTraining,
  upcomingJSMTraining,
  completedConfluenceAdvancedTraining,
  completedTrelloTraining,
];

// Mock response data structure (if needed for API mocking)
export interface LiveTrainingSessionData {
  id: string;
  contentfulId: string;
  courseTitleExternal: string;
  tagline: string;
  scheduledDate: string;
  status: 'upcoming' | 'completed';
  enrolled: boolean;
  product: string[];
  iltType: string[];
  host: string;
  slug: string;
  duration?: number;
  learningLevel?: string;
}

export const liveTrainingAPIResponseMock: LiveTrainingSessionData[] = [
  {
    id: 'ilt-1',
    contentfulId: 'ilt-advanced-jira-admin',
    courseTitleExternal: 'Advanced Jira Administration',
    tagline: 'Master advanced Jira configuration, automation, and administration best practices',
    scheduledDate: '2025-11-15T18:00:00Z',
    status: 'upcoming',
    enrolled: true,
    product: ['Jira'],
    iltType: ['Team training'],
    host: 'John Smith',
    slug: 'advanced-jira-admin',
    duration: 240,
    learningLevel: 'Advanced',
  },
  {
    id: 'ilt-2',
    contentfulId: 'ilt-confluence-fundamentals',
    courseTitleExternal: 'Confluence Fundamentals',
    tagline: 'Learn the basics of Confluence for effective team collaboration and documentation',
    scheduledDate: '2025-11-20T22:00:00Z',
    status: 'upcoming',
    enrolled: true,
    product: ['Confluence'],
    iltType: ['Public class'],
    host: 'Jane Doe',
    slug: 'confluence-fundamentals',
    duration: 180,
    learningLevel: 'Beginner',
  },
  {
    id: 'ilt-3',
    contentfulId: 'ilt-jsm-essentials',
    courseTitleExternal: 'Jira Service Management Essentials',
    tagline: 'ITSM best practices and implementation strategies with Jira Service Management',
    scheduledDate: '2025-12-01T17:00:00Z',
    status: 'upcoming',
    enrolled: false,
    product: ['Jira Service Management'],
    iltType: ['Public class'],
    host: 'Mike Johnson',
    slug: 'jsm-essentials',
    duration: 300,
    learningLevel: 'Intermediate',
  },
  {
    id: 'ilt-4',
    contentfulId: 'ilt-agile-jira',
    courseTitleExternal: 'Agile with Jira',
    tagline: 'Implementing agile methodologies and best practices using Jira',
    scheduledDate: '2025-10-25T17:00:00Z',
    status: 'completed',
    enrolled: true,
    product: ['Jira'],
    iltType: ['Team training'],
    host: 'David Lee',
    slug: 'agile-jira',
    duration: 240,
    learningLevel: 'Intermediate',
  },
  {
    id: 'ilt-5',
    contentfulId: 'ilt-confluence-advanced',
    courseTitleExternal: 'Confluence Advanced',
    tagline: 'Advanced content creation, templates, and collaboration features',
    scheduledDate: '2025-10-18T22:00:00Z',
    status: 'completed',
    enrolled: true,
    product: ['Confluence'],
    iltType: ['Public class'],
    host: 'Emily Chen',
    slug: 'confluence-advanced',
    duration: 180,
    learningLevel: 'Advanced',
  },
];

// Helper function to convert API response to card props
export const convertToCardProps = (apiData: LiveTrainingSessionData): LiveTrainingCardProps => {
  const date = new Date(apiData.scheduledDate);
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });

  return {
    id: apiData.id,
    title: apiData.courseTitleExternal,
    subtitle: apiData.tagline,
    dateTime: `${formattedDate} at ${formattedTime}`,
    status: apiData.status as TrainingStatus,
    enrolled: apiData.enrolled,
    product: apiData.product[0] || 'Atlassian',
    label: apiData.iltType[0],
    host: apiData.host,
    detailsLink: `/instructor-led-training/${apiData.slug}`,
    showAddToCalendar: apiData.status === 'upcoming',
    showDownloadMaterials: apiData.status === 'completed' && apiData.enrolled,
  };
};

// Convert all API mock data to card props
export const liveTrainingCardPropsMock: LiveTrainingCardProps[] = liveTrainingAPIResponseMock.map(convertToCardProps);

/**
 * Converts LiveTrainingCardProps to FlattenedLearningInstance format
 * This matches the expected format from the ALM API transformer
 */
export const convertToFlattenedInstance = (cardProps: LiveTrainingCardProps): FlattenedLearningInstance => ({
  instance: {
    id: cardProps.id,
    type: 'learningObjectInstance',
    name: cardProps.title,
    dateTime: cardProps.dateTime,
    status: cardProps.status,
    enrolled: cardProps.enrolled,
    product: cardProps.product,
    label: cardProps.label,
    host: cardProps.host,
    detailsLink: cardProps.detailsLink,
  },
  id: `course:${cardProps.id}`,
  type: 'learningObject',
  title: cardProps.title,
  description: cardProps.subtitle,
  tags: [cardProps.product],
});

// Convert all training sessions to FlattenedLearningInstance format for use in loader
export const allTrainingSessionsFlattened: FlattenedLearningInstance[] =
  allTrainingSessions.map(convertToFlattenedInstance);
